"use strict";
module.exports = {
    entityModel: 'integration',
    events: {
        INTEGRATION_CREATED: 'INTEGRATION_CREATED',
        INTEGRATION_UPDATED: 'INTEGRATION_UPDATED',
        INTEGRATION_ACTIVATED: 'INTEGRATION_ACTIVATED',
        INTEGRATION_DEACTIVATED: 'INTEGRATION_DEACTIVATED',
        INTEGRATION_UPSERT_RECYCLE_ARTICLE_TO_FORTNOX: 'INTEGRATION_UPSERT_RECYCLE_ARTICLE_TO_FORTNOX',
        INTEGRATION_RUN_STARTED: 'INTEGRATION_RUN_STARTED',
        INTEGRATION_RUN_STOPPED: 'INTEGRATION_RUN_STOPPED',
        INTEGRATION_RUN_COMPLETED: 'INTEGRATION_RUN_COMPLETED',
        INTEGRATION_RUN_RESET: 'INTEGRATION_RUN_RESET',
    },
    actions: {
        get: 'v1.integration.get',
        list: 'v1.integration.list',
        createIntegration: 'v1.integration.createIntegration',
        activate: 'v1.integration.activate',
        deactivate: 'v1.integration.deactivate',
        sendTechnicalEmail: 'v1.integration.sendTechnicalEmail',
        setUpExternalFortnoxConnection: 'v1.integration.setUpExternalFortnoxConnection',
        updateFortnoxIntegration: 'v1.integration.updateFortnoxIntegration',
        ensureRecycleArticlesInExternalFortnox: 'v1.integration.ensureRecycleArticlesInExternalFortnox',
        setUpInternalFortnoxConnection: 'v1.integration.setUpInternalFortnoxConnection',
        setUpExtendConnection: 'v1.integration.setUpExtendConnection',
        setUpWhgroupConnection: 'v1.integration.setUpWhgroupConnection',
        resetIntegrationRun: 'v1.integration.resetIntegrationRun',
        startIntegrationRun: 'v1.integration.startIntegrationRun',
        stopIntegrationRun: 'v1.integration.stopIntegrationRun',
        triggerScheduledRun: 'v1.integration.triggerScheduledRun',
        writeIncoming: 'v1.integration.writeIncoming',
        writeOutgoing: 'v1.integration.writeOutgoing',
        writeGetEndpoint: 'v1.integration.writeGetEndpoint',
        writeScheduledRun: 'v1.integration.writeScheduledRun',
        deleteIntegrationRun: 'v1.integration.deleteIntegrationRun',
        upsert: 'v1.integration.upsert',
        upsertWhenEmpty: 'v1.integration.upsertWhenEmpty',
        updateWhenEmpty: 'v1.integration.updateWhenEmpty',
        update: 'v1.integration.update',
    },
    incomingAuthorizations: {
        Bearer: 'Bearer',
        None: 'None',
        SHA256MAC: 'SHA256MAC',
    },
    outgoingAuthorizations: {
        Bearer: 'Bearer',
        None: 'None',
        Basic: 'Basic',
    },
    types: {
        EDI: 'EDI',
        FORTNOX: 'FORTNOX',
        WHGROUP: 'WHGROUP',
        EXTEND: 'EXTEND',
        OTHER: 'OTHER',
    },
    statuses: {
        waiting: 'waiting',
        'files received': 'files received',
        development: 'development',
        test: 'test',
        production: 'production',
    },
    getEndpoints: {
        entityNames: {
            article: 'article',
            order: 'order',
            supplier: 'supplier',
            supplierCustomer: 'supplierCustomer',
            purchaseOrder: 'purchaseOrder',
            invoice: 'invoice',
            priceList: 'priceList',
            settlement: 'settlement',
            customerSubUnit: 'customerSubUnit',
        },
    },
    incomings: {
        entityNames: {
            article: 'article',
            order: 'order',
            supplier: 'supplier',
            supplierCustomer: 'supplierCustomer',
            purchaseOrder: 'purchaseOrder',
            invoice: 'invoice',
            priceList: 'priceList',
            settlement: 'settlement',
            customerSubUnit: 'customerSubUnit',
        },
        incomingChannels: {
            'FTP-file': 'FTP-file',
            'HTTP-POST': 'HTTP-POST',
            FORTNOX: 'FORTNOX',
            CRONJOB: 'CRONJOB',
            INTERNALCALL: 'INTERNALCALL',
        },
        readers: {
            NOOP: 'NOOP',
            XML: 'XML',
            JSON: 'JSON',
            EDIFACTD96APRICAT: 'EDIFACTD96APRICAT',
            EDIFACTD96AORDERS: 'EDIFACTD96AORDERS',
            D96AORDERRSP: 'D96AORDERRSP',
            CSV: 'CSV',
            PYRAMIDPRICEREADER: 'PYRAMIDPRICEREADER',
            FRESHXMLREADER: 'FRESHXMLREADER',
            FRESHCSVARTICLEREADER: 'FRESHCSVARTICLEREADER',
            FXORDER: 'FXORDER',
            FXORDERFEEDBACK: 'FXORDERFEEDBACK',
            FXCUSTOMER: 'FXCUSTOMER',
            FXARTICLESANDPRICES: 'FXARTICLESANDPRICES',
            FXSTOCKQUANTITIES: 'FXSTOCKQUANTITIES',
            WHGROUPPRICES: 'WHGROUPPRICES',
            WHGROUPCUSTOMERS: 'WHGROUPCUSTOMERS',
            BRIGHTCOMCUSTOMER: 'BRIGHTCOMCUSTOMER',
            BRIGHTCOMSTOCKQUANTITY: 'BRIGHTCOMSTOCKQUANTITY',
            BRIGHTCOMPRICELISTENTRY: 'BRIGHTCOMPRICELISTENTRY',
            BRIGHTCOMPRICELISTS: 'BRIGHTCOMPRICELISTS',
            BRIGHTCOMORDER: 'BRIGHTCOMORDER',
            BRIGHTCOMARTICLE: 'BRIGHTCOMARTICLE',
            EXTENDWEBHOOK: 'EXTENDWEBHOOK',
            EXTENDORDER: 'EXTENDORDER',
            EXTENDSTOCKQUANTITY: 'EXTENDSTOCKQUANTITY',
            EXTENDPURCHASEORDER: 'EXTENDPURCHASEORDER',
            EXTENDRETURNORDER: 'EXTENDRETURNORDER',
            EXTENDINVOICE: 'EXTENDINVOICE',
            EXTENDCUSTOMER: 'EXTENDCUSTOMER',
            GOLDENEDIARTICLE: 'GOLDENEDIARTICLE',
            HICOREARTICLE: 'HICOREARTICLE',
            HICORECUSTOMER: 'HICORECUSTOMER',
            HICORECUSTOMERORDER: 'HICORECUSTOMERORDER',
        },
    },
    outgoings: {
        entityNames: {
            article: 'article',
            order: 'order',
            supplier: 'supplier',
            supplierCustomer: 'supplierCustomer',
            purchaseOrder: 'purchaseOrder',
            invoice: 'invoice',
            priceList: 'priceList',
            settlement: 'settlement',
            customerSubUnit: 'customerSubUnit',
        },
        triggeredByEvents: {
            ORDER_PLACED: 'ORDER_PLACED',
            ORDER_APPROVED: 'ORDER_APPROVED',
            ORDER_UPDATED: 'ORDER_UPDATED',
            ORDER_CANCELLED: 'ORDER_CANCELLED',
            ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER: 'ORDER_CONNECTED_TO_SUPPLIER_CUSTOMER',
            'ORDER_*': 'ORDER_*',
            PURCHASE_ORDER_REQUESTED: 'PURCHASE_ORDER_REQUESTED',
            PURCHASE_ORDER_SENT_TO_SUPPLIER: 'PURCHASE_ORDER_SENT_TO_SUPPLIER',
            'SUPPLIER_CUSTOMER_*': 'SUPPLIER_CUSTOMER_*',
            CUSTOMER_SUB_UNIT_UPDATED: 'CUSTOMER_SUB_UNIT_UPDATED',
            SUPPLIER_CUSTOMER_CREATED: 'SUPPLIER_CUSTOMER_CREATED',
            'ARTICLE_*': 'ARTICLE_*',
            ARTICLE_UPDATED: 'ARTICLE_UPDATED',
            'SUPPLIER_*': 'SUPPLIER_*',
            SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER: 'SUPPLIER_SALES_REPORT_SENT_TO_SUPPLIER',
            SETTLEMENT_SENT_TO_SUPPLIER_ORGANIZATION: 'SETTLEMENT_SENT_TO_SUPPLIER_ORGANIZATION',
        },
        writers: {
            EDIFACTD96AORDERS: 'EDIFACTD96AORDERS',
            PEPPOLBISORDERING32: 'PEPPOLBISORDERING32',
            TEMPLATE: 'TEMPLATE',
            PYRAMIDORDER: 'PYRAMIDORDER',
            NOOP: 'NOOP',
            EVENT: 'EVENT',
            FXORDER: 'FXORDER',
            FXARTICLE: 'FXARTICLE',
            FXCUSTOMER: 'FXCUSTOMER',
            BRIGHTCOMORDER: 'BRIGHTCOMORDER',
            BRIGHTCOMCUSTOMER: 'BRIGHTCOMCUSTOMER',
            BRIGHTCOMARTICLE: 'BRIGHTCOMARTICLE',
            EXTENDARTICLE: 'EXTENDARTICLE',
            EXTENDARTICLEFROMPURCHASEORDER: 'EXTENDARTICLEFROMPURCHASEORDER',
            EXTENDORDER: 'EXTENDORDER',
            EXTENDPURCHASEORDER: 'EXTENDPURCHASEORDER',
            EXTENDCUSTOMER: 'EXTENDCUSTOMER',
            EXTENDCUSTOMERFROMORDER: 'EXTENDCUSTOMERFROMORDER',
            HICORECUSTOMERORDER: 'HICORECUSTOMERORDER',
            HICORECUSTOMER: 'HICORECUSTOMER',
        },
        outgoingChannels: {
            'v1.outgoingMessage.writeFtpFile': 'v1.outgoingMessage.writeFtpFile',
            'v1.outgoingMessage.writeSftpFile': 'v1.outgoingMessage.writeSftpFile',
            'v1.email.sendEmail': 'v1.email.sendEmail',
            'v1.fortnox-external.sendOrder': 'v1.fortnox-external.sendOrder',
            'v1.fortnox-external.cancelOrder': 'v1.fortnox-external.cancelOrder',
            'v1.fortnox-external.sendCustomer': 'v1.fortnox-external.sendCustomer',
            'v1.fortnox-external.sendArticle': 'v1.fortnox-external.sendArticle',
            'v1.fortnox-external.sendSupplier': 'v1.fortnox-external.sendSupplier',
            'v1.fortnox-external.sendSupplierSalesReport': 'v1.fortnox-external.sendSupplierSalesReport',
            'v1.fortnox-external.sendSettlement': 'v1.fortnox-external.sendSettlement',
            'v1.brightcom.sendOrder': 'v1.brightcom.sendOrder',
            'v1.brightcom.sendCustomer': 'v1.brightcom.sendCustomer',
            'v1.brightcom.sendArticle': 'v1.brightcom.sendArticle',
            'v1.golden-edi.sendArticle': 'v1.golden-edi.sendArticle',
            'v1.whgroup.sendOrder': 'v1.whgroup.sendOrder',
            'v1.whgroup.sendCustomer': 'v1.whgroup.sendCustomer',
            'v1.extend.createArticle': 'v1.extend.createArticle',
            'v1.extend.updateArticle': 'v1.extend.updateArticle',
            'v1.extend.sendOrder': 'v1.extend.sendOrder',
            'v1.extend.sendPurchaseOrder': 'v1.extend.sendPurchaseOrder',
            'v1.extend.sendCustomer': 'v1.extend.sendCustomer',
            'v1.extend.updateCustomer': 'v1.extend.updateCustomer',
            'v1.article.handlePublications': 'v1.article.handlePublications',
            'v1.hiCore.SendCustomer': 'v1.hiCore.SendCustomer',
            'v1.hiCore.SendOrder': 'v1.hiCore.SendOrder',
        },
    },
    scheduledRuns: {
        jobNames: {
            'hi-core-import': 'hi-core-import',
            'extend-import-return-orders': 'extend-import-return-orders',
            'handle-incoming-files': 'handle-incoming-files',
            'privab-import-articles': 'privab-import-articles',
            'wh-group-import-stock-quantities': 'wh-group-import-stock-quantities',
            'wh-group-import-articles-customers': 'wh-group-import-articles-customers',
            'sync-external-fortnox-for-integration': 'sync-external-fortnox-for-integration',
            'sync-external-fortnox-price-lists-for-integration': 'sync-external-fortnox-price-lists-for-integration',
        },
    },
    integrationRuns: {
        statuses: {
            Error: 'Error',
            Success: 'Success',
            Started: 'Started',
            Undetermined: 'Undetermined',
        },
    },
};
